import dayjs from "dayjs";

export const getDocumentExpiryStats = (
  employeeData = [],
  documentName
) => {
  const stats = {
    expired: [],
    oneToSevenDays: [],
    eightToThirtyDays: [],
    thirtyOneToSixtyDays: [],
  };

  employeeData.forEach((employee) => {
    const document = employee?.documents?.find(
      (doc) => doc.name === documentName
    );

    if (!document?.expiryDate) return;

    const today = dayjs().startOf("day");
    const expiryDate = dayjs(document.expiryDate).startOf("day");

    const diffDays = expiryDate.diff(today, "day");

    if (diffDays <= 0) {
      stats.expired.push(employee);
    } else if (diffDays <= 7) {
      stats.oneToSevenDays.push(employee);
    } else if (diffDays <= 30) {
      stats.eightToThirtyDays.push(employee);
    } else if (diffDays <= 60) {
      stats.thirtyOneToSixtyDays.push(employee);
    }
  });

  return stats;
};